import { render, staticRenderFns } from "./card-group.vue?vue&type=template&id=e5207868&scoped=true"
import script from "./card-group.vue?vue&type=script&lang=js"
export * from "./card-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5207868",
  null
  
)

export default component.exports